import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-m-cities',
  templateUrl: './m-cities.component.html',
  styleUrls: ['./m-cities.component.scss'],
        encapsulation: ViewEncapsulation.None
})
export class MCitiesComponent implements OnInit {


   public cities: any[] = [];
  public messages: any = {};
 
   constructor( 
     private apisService: ApisService,
     // private loadingService: Loadingscr,
     private router: Router,        private toastr : ToastrService,
       public  translate: TranslateService
   ) {} 
 
   public currentPage = 1; 
   public itemsPerPage = 10;
   public totalItems = 0;
 selectedCountryId: string = "all";
allCities: any[] = [];

   public tempData = [];
 
   @ViewChild(DatatableComponent) table: DatatableComponent;
 
   public ColumnMode = ColumnMode;
   public SelectionType = SelectionType;v
   countries: any = [];

   ngOnInit(): void {
    //  this.apisService.getCountries().subscribe({ 
    //    next:(response:any)=> { 
    //      this.countries = response.data || [] ;
    //      console.log('response is' , this.countries)
    //    }, 
    //    error:(err)=> { 
    //      console.log('error in fetching', err)
    //    }
    //  }) 
    this.getCities();
      this.getCountries();

      this.setDatatableMessages(); // set initial messages
 
     // listen for language change dynamically
     this.translate.onLangChange.subscribe(() => {
       this.setDatatableMessages();
     });
 
   }
 
    private setDatatableMessages() {
     this.messages = {
       totalMessage: this.translate.instant('MENU.DASHBOARD.total')
     };
   }
 
getCities(){ 
  this.apisService.getCitiesM().subscribe({
    next: (response: any) => {
      this.allCities = response.data || [];
      this.cities = [...this.allCities]; // default load all

      this.totalItems = this.cities.length;
      console.log("All cities:", this.cities);
    },
    error: (error: any) => {
      console.log(error);
    }
  });
}

  
  
  /*----------  Handling image Error  ----------*/
  onImageError(event) {
   event.target.src = 'assets/images/logo/12.png';
  }
   addCoupon() {
     this.router.navigate(["main/coupons/add-coupon"]);
   }
 
   
 
  
 
   filterUpdate(event) {
     const val = event.target.value.toLowerCase();
     this.cities = this.tempData.filter((d) =>
       d.code.toLowerCase().includes(val)
     );
     this.table.offset = 0;
   }
 
 
   
    /*----------  deleting products  ----------*/
  deleteCity(id:any){ 
   console.log(id ,' delete id');
   this.apisService.DeleteCities(id).subscribe({
     next: (response: any) => {
    this.toastr.success(
         this.translate.instant('MENU.DASHBOARD.DELETED_SUCCESSFULLY')
       );       this.getCities();
     },
     error: (error: any) => {
       console.log(error);
    this.toastr.error(
         this.translate.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
       );    }
   }
     
   )
  } 
 
 editCity(cityId: number) {
   this.router.navigate(['/edit-m-cities', cityId]);
 }

onCountryChange(): void {
  if (this.selectedCountryId === "all") {
    this.cities = [...this.allCities];
  } else {
    this.cities = this.allCities.filter(
      c => c.country_id == this.selectedCountryId
    );
  }

  // reset table pagination
  if (this.table) {
    this.table.offset = 0;
  }

  this.totalItems = this.cities.length;
}


  //  getCities(nationalityId: string): void {
  //   this.apiService.getCitiesById(nationalityId).subscribe({ 
  //     next: (response: any) => { 
  //       this.cities = response.data || [];
  //     }, 
  //     error: (err) => { 
  //       console.log('Error fetching cities:', err);
  //       this.cities = [];
  //       this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_cities'));
  //     }
  //   });
  // }


   getCountries(): void {
    this.apisService.getCountriesM().subscribe({ 
      next: (response: any) => { 
        this.countries = response.data || [];
      }, 
      error: (err) => { 
        console.log('Error fetching countries:', err);
        this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_countries'));
      }
    });
  }

}
